import { createSlice } from '@reduxjs/toolkit';
import { convertToBuilderNotation } from '../../utils';

export {
  setPriceTotal,
  setDiscountPriceTotal,
  setSelectedAttributesValues,
  setSelectedVariantsForBundleItemProducts,
} from './index.migrated';

export const bundlePdpSlice = createSlice({
  name: 'bundlePdp',
  initialState: {
    selectedVariantsForBundleItemProducts: {},
    selectedAttributesValues: {},
    priceTotal: {},
    discountPriceTotal: {},
  },
  reducers: {
    setSelectedVariantsForBundleItemProducts: (state, data) => ({
      ...state,
      selectedVariantsForBundleItemProducts:
        data.payload.selectedVariantsForBundleItemProducts,
    }),
    setSelectedAttributeValues: (state, data) => ({
      ...state,
      selectedAttributesValues: {
        ...state.selectedAttributesValues,
        ...data.payload,
      },
    }),
    setPriceTotal: (state, data) => ({
      ...state,
      priceTotal: data.payload,
    }),
    setDiscountPriceTotal: (state, data) => ({
      ...state,
      discountPriceTotal: data.payload,
    }),
  },
  extraReducers: convertToBuilderNotation({}),
});

export default bundlePdpSlice.reducer;
